/* eslint-disable no-use-before-define */
import * as React from 'react';
import cls from 'classnames';

import styles from './index.module.sass';

interface Props {
  className?: string;
  onClick: () => void;
}

export const ExpandButton = ({ className, onClick }: Props ) => (
  <button
    type="button"
    className={cls(
      styles.button,
      'bg-transparent border-0 p-0 font-weight-bold fs-5 text-secondary',
      className
    )}
    onClick={onClick}
  >
    Read More
  </button>
);
